import { connectLoadable, createParallelGuard } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import NetworthSummary from 'components/features/pfm/NetworthSummary/NetworthSummary'
import { peergroupsGuard } from 'guards/globalGuards'
import { networthSummaryFirstRequestGuard } from 'guards/networthGuards'

const guards: Guards = [
  createParallelGuard(
    networthSummaryFirstRequestGuard,
    peergroupsGuard,
  ),
]

const NetworthSummaryContainer = connectLoadable(guards)()(NetworthSummary)

export default NetworthSummaryContainer
